import context from '../../main.js';
export async function merger(body) {
  let result = await context.$http.post('/onlineTask', body);
  if (result.data.code === 200) {
    return result.data.data;
  }

  return false;
}
export async function checkStatus(taskId) {
  let result = await context.$http.get(`/onlineTask/getProgress?taskId=${taskId}`);
  if (result.data.code === 200) {
    return result.data.data;
  }
  return false;
}
